declare const sgSettings: any;

export function getGameSlug(): string {
  try {
    return sgSettings.config.game.slug;
  } catch (e) {
    return 'unknown';
  }
}
